// Разбор ответа бэкенда на «что показать менеджеру».
//
// Бэкенд заворачивает наши же ArgumentException в общий конверт и приклеивает
// к тексту стек:
//
//   { "message": "Произошла ошибка",
//     "error": "Общая ошибка: Клиент сейчас подписывает согласия. Дождитесь…
//               \nStack:   at doscar.Data.Shop.Mocks.MockCreditPlatform…" }
//
// Менеджеру нужна только первая фраза. Стек, номера строк и имена классов он
// прочитать не может и всё равно придёт с вопросом — поэтому вытаскиваем
// человеческую часть, а техническую оставляем разработчику в модалке.

// Мусор, после которого начинается стек или служебная часть ответа.
const TECHNICAL_MARKERS = [
  '\nStack',
  'Stack:',
  '\n   at ',
  ' at doscar.',
  ' at Microsoft.',
  ' at System.',
  'System.ArgumentException',
  'System.Exception',
];

const PREFIXES = ['Общая ошибка:', 'Произошла ошибка:', 'Ошибка:'];

const cut = (text) => {
  let result = text;
  TECHNICAL_MARKERS.forEach((marker) => {
    const index = result.indexOf(marker);
    if (index > 0) result = result.slice(0, index);
  });
  return result;
};

const stripPrefix = (text) => {
  let result = text.trim();
  PREFIXES.forEach((prefix) => {
    if (result.startsWith(prefix)) result = result.slice(prefix.length).trim();
  });
  return result;
};

// Текст без единой кириллической буквы — это почти наверняка сообщение от
// стороннего сервиса или обрывок стека: показывать его в тосте бессмысленно.
const looksHuman = (text) =>
  text.length >= 10 && text.length <= 400 && /[а-яё]/i.test(text) && !text.startsWith('{');

/**
 * Понятный менеджеру текст ошибки или null, если такого текста нет
 * (тогда показываем модалку с техническими подробностями).
 */
export const humanErrorText = (payload) => {
  if (!payload) return null;

  const raw =
    typeof payload === 'string'
      ? payload
      : payload.errorMessage || payload.error || payload.message;

  if (typeof raw !== 'string') return null;

  const text = stripPrefix(cut(raw)).replace(/\s+/g, ' ').trim();

  // «Произошла ошибка» — это заголовок конверта, а не объяснение.
  if (!looksHuman(text) || text === 'Произошла ошибка') return null;

  return text;
};
